import { CONFIG } from 'src/config-global';
import ServiceRequest from '../ServiceRequest';

export const getModuleListData = async (application_name: string, role: string): Promise<any> => {
  const url = `${CONFIG.baseUrl}/${application_name}/${role}/list/all`;
  return ServiceRequest.get(url);
};

export const getPageForm = async (module_name: string): Promise<any> => {
  const url = `${CONFIG.baseUrl}/auth/${module_name}/get-page-form`;
  return ServiceRequest.get(url);
};

export const getUserPageForm = async (module_name: string): Promise<any> => {
  const url = `${CONFIG.baseUrl}/user/${module_name}/get-page-form`;
  return ServiceRequest.get(url);
};

export const getDefaultValues = async (module_name: string, values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/data/auth/${module_name}/get-default-values`;
  return ServiceRequest.post(url, { payload: values });
};

export const getUserDefaultValues = async (module_name: string, values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/data/user/${module_name}/get-default-values`;
  return ServiceRequest.post(url, { payload: values });
};

export const getAdminDefaultValues = async (module_name: string, values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/data/admin/${module_name}/get-default-values`;
  return ServiceRequest.post(url, { payload: values });
};

export const getAdminPageForm = async (module_name: string): Promise<any> => {
  const url = `${CONFIG.baseUrl}/admin/${module_name}/get-page-form`;
  return ServiceRequest.get(url);
};

export const getAdminPermissions = async (): Promise<any> => {
  const url = `${CONFIG.baseUrl}/admin/get-permissions`;
  return ServiceRequest.get(url);
};

export const getAdminSubModulePageForm = async (
  module_name: string,
  submodule_name: string
): Promise<any> => {
  const url = `${CONFIG.baseUrl}/admin/${module_name}/submodule/${submodule_name}/get-submodule-page-form`;
  return ServiceRequest.get(url);
};

export const getUserSubModulePageForm = async (
  module_name: string,
  submodule_name: string
): Promise<any> => {
  const url = `${CONFIG.baseUrl}/user/${module_name}/submodule/${submodule_name}/get-submodule-page-form`;
  return ServiceRequest.get(url);
};

export const getAdminModulePageData = async (module_name: string, values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/data/admin/${module_name}/get-page-data`;
  return ServiceRequest.post(url, { payload: values });
};

export const getUserModulePageData = async (module_name: string, values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/data/user/${module_name}/get-page-data`;
  return ServiceRequest.post(url, { payload: values });
};

export const deleteAdminModuleRecord = async (module_name: string, values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/data/admin/${module_name}/execute-delete`;
  return ServiceRequest.post(url, { payload: values });
};

export const getAdminSubModulePageData = async (
  module_name: string,
  submodule_name: string,
  values: any
): Promise<any> => {
  const url = `${CONFIG.baseUrl}/data/admin/${module_name}/submodule/${submodule_name}/get-page-data`;
  return ServiceRequest.post(url, { payload: values });
};

export const executeUserActions = async (module_name: string, values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/data/user/${module_name}/execute-action`;
  return ServiceRequest.post(url, { payload: values });
};
export const executeAuthProcedure = async (values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/auth/execute-procedure`;
  return ServiceRequest.post(url, { payload: values });
};

export const executeAdminActions = async (
  module_name: string,
  submodule_name: string,
  values: any
): Promise<any> => {
  const url = `${CONFIG.baseUrl}/data/admin/${module_name}/submodule/${submodule_name}/execute-action`;
  return ServiceRequest.post(url, { payload: values });
};

export const executeStoredProcedure = async (module_name: string, values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/admin/${module_name}/execute-procedure`;
  return ServiceRequest.post(url, { payload: values });
};

export const sendEmail = async (module_name: string, values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/admin/${module_name}/send-email`;
  return ServiceRequest.post(url, { payload: values });
};

export const signOutUser = async (data: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/auth/logout`;
  return ServiceRequest.post(url, { payload: data });
};

export const getToolbarOptions = async (values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/admin/getToolbarOptions`;
  return ServiceRequest.post(url, { payload: values });
};

export const getBannerDetails = async (values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/user/get_banner_values`;
  return ServiceRequest.post(url, { payload: values });
};
export const getPersonalInfo = async (values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/user/get_profile_info`;
  return ServiceRequest.post(url, { payload: values });
};
export const editPersonalInfo = async (values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/user/edit_profile_info`;
  return ServiceRequest.post(url, { payload: values });
};
export const editBasicInfo = async (values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/user/edit_basic_info`;
  return ServiceRequest.post(url, { payload: values });
};
export const resetSecurityQuestion = async (values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/auth/change_security_question`;
  return ServiceRequest.post(url, { payload: values });
};
export const updatePassword = async (values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/auth/change_password`;
  return ServiceRequest.post(url, { payload: values });
};
export const getAppConfig = async (): Promise<any> => {
  const url = `${CONFIG.baseUrl}/user/get_application_configuration`;
  return ServiceRequest.get(url);
};

export const getDndDraggableList = async (module_name: string, values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/data/user/${module_name}/get-dnd-draggable-list`;
  return ServiceRequest.post(url, { payload: values });
};

export const chatDataService = async (
  role: string,
  module_name: string,
  conversation_type: string,
  values: any
): Promise<any> => {
  const url = `${CONFIG.baseUrl}/data/${role}/${module_name}/${conversation_type}/messages`;
  return ServiceRequest.post(url, { payload: values });
};

export const notificationDataService = async (
  role: string,
  module_name: string,
  notification_type: string,
  values: any
): Promise<any> => {
  const url = `${CONFIG.baseUrl}/data/${role}/${module_name}/${notification_type}/notifications`;
  return ServiceRequest.post(url, { payload: values });
};

// Admin Configuration Services
export const getAdminConfiguration = async (config_key: string): Promise<any> => {
  const url = `${CONFIG.baseUrl}/admin/get-configuration/${config_key}`;
  return ServiceRequest.get(url);
};

// Get timeout configuration for authenticated users (admin or regular user)
export const getTimeoutConfig = async (): Promise<any> => {
  const url = `${CONFIG.baseUrl}/auth/get-timeout-config`;
  return ServiceRequest.get(url);
};

export const getAllAdminConfigurations = async (): Promise<any> => {
  const url = `${CONFIG.baseUrl}/admin/get-configurations`;
  return ServiceRequest.get(url);
};

export const updateAdminConfiguration = async (config_key: string, config_value: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/admin/update-configuration`;
  const EncryptUtils = (await import('src/utils/EncryptUtils')).default;
  const encryptedPayload = EncryptUtils.encryptedData({ config_key, config_value });
  return ServiceRequest.post(url, { payload: { tk: encryptedPayload } });
};

export const revertToDefaults = async (): Promise<any> => {
  const url = `${CONFIG.baseUrl}/admin/revert-to-defaults`;
  return ServiceRequest.post(url, { payload: {} });
};

export const revertTabToDefaults = async (submodule_name: string): Promise<any> => {
  const url = `${CONFIG.baseUrl}/admin/revert-tab-to-defaults`;
  const EncryptUtils = (await import('src/utils/EncryptUtils')).default;
  const encryptedPayload = EncryptUtils.encryptedData({ submodule_name });
  return ServiceRequest.post(url, { payload: { tk: encryptedPayload } });
};

export const revertNotificationsToDefaults = async (): Promise<any> => {
  const url = `${CONFIG.baseUrl}/admin/revert-notifications-to-defaults`;
  return ServiceRequest.post(url, { payload: {} });
};

// Email Templates
export const getEmailTemplates = async (): Promise<any> => {
  const url = `${CONFIG.baseUrl}/admin/control-panel/email-templates`;
  return ServiceRequest.get(url);
};

export const getEmailTemplate = async (template_id: string): Promise<any> => {
  const url = `${CONFIG.baseUrl}/admin/control-panel/email-templates/${template_id}`;
  return ServiceRequest.get(url);
};

export const saveEmailTemplate = async (
  template_id: string, 
  title: string,
  subject: string, 
  body: string,
  fields: string[],
  type: string
): Promise<any> => {
  const url = `${CONFIG.baseUrl}/admin/control-panel/email-templates/${template_id}`;
  const EncryptUtils = (await import('src/utils/EncryptUtils')).default;
  const encryptedPayload = EncryptUtils.encryptedData({ 
    title,
    subject, 
    body,
    fields: JSON.stringify(Array.isArray(fields) ? fields : []),
    type
  });
  return ServiceRequest.post(url, { payload: { tk: encryptedPayload } });
};

export const revertEmailTemplate = async (template_id: string): Promise<any> => {
  const url = `${CONFIG.baseUrl}/admin/control-panel/email-templates/${template_id}/revert`;
  return ServiceRequest.post(url, { payload: {} });
};

export const resolveEmailTemplates = async (template_ids: string[]): Promise<any> => {
  const url = `${CONFIG.baseUrl}/admin/control-panel/email-templates/resolve`;
  const EncryptUtils = (await import('src/utils/EncryptUtils')).default;
  // Encrypt the template_ids array as JSON string since encryptedData expects Record<string, string | number>
  const encryptedPayload = EncryptUtils.encryptedData({ template_ids: JSON.stringify(template_ids) });
  return ServiceRequest.post(url, { payload: { tk: encryptedPayload } });
};

export const getEmailTemplatesByType = async (type: string, namesOnly: boolean = false): Promise<any> => {
  const url = `${CONFIG.baseUrl}/admin/control-panel/email-templates/by-type/${encodeURIComponent(type)}${namesOnly ? '?namesOnly=true' : ''}`;
  return ServiceRequest.get(url);
};

export const createEmailTemplate = async (
  name_id: string,
  title: string,
  subject: string,
  body: string,
  fields: string[],
  template_type: string = 'manual',
  type: string = 'Pre-Application'
): Promise<any> => {
  const url = `${CONFIG.baseUrl}/admin/control-panel/email-templates`;
  const EncryptUtils = (await import('src/utils/EncryptUtils')).default;
  // Stringify fields array since encryptedData expects Record<string, string | number>
  const encryptedPayload = EncryptUtils.encryptedData({
    name_id,
    title,
    subject,
    body,
    fields: JSON.stringify(Array.isArray(fields) ? fields : []),
    template_type,
    type
  });
  return ServiceRequest.post(url, { payload: { tk: encryptedPayload } });
};

export const deleteEmailTemplate = async (template_id: string): Promise<any> => {
  const url = `${CONFIG.baseUrl}/admin/control-panel/email-templates/${template_id}`;
  return ServiceRequest.delete(url, { payload: {} });
};

export const syncEmailTemplatesFromJson = async (): Promise<any> => {
  const url = `${CONFIG.baseUrl}/admin/control-panel/email-templates/sync`;
  return ServiceRequest.post(url, { payload: {} });
};

export const previewEmailTemplate = async (
  template_id: string,
  subject: string,
  body: string,
  subject_params: any,
  content_params: any
): Promise<any> => {
  const url = `${CONFIG.baseUrl}/admin/control-panel/email-templates/${template_id}/preview`;
  const EncryptUtils = (await import('src/utils/EncryptUtils')).default;
  const encryptedPayload = EncryptUtils.encryptedData({
    subject,
    body,
    subject_params,
    content_params
  });
  return ServiceRequest.post(url, { payload: { tk: encryptedPayload } });
};